import { employees } from './Employees.reducer';
import { employeeProducts } from './EmployeeProducts.reducer';
import { employeeMediaDefault } from './EmployeeMediaDefault.reducer';
import { resources } from './Resources.reducer';
import { shop } from './Shop.reducer';
import { productCategories } from './ProductCategories.reducers';
import { products } from './Products.reducer';
import { productResources } from './ProductResources.reducer';
import { timelines } from './TimeLine.reducer';
import { fieldsDefination } from './FieldsDefination.reducer';
import { retailer } from './Retailer.reducer';
import { shopAlertMessage } from './AlertMessage.reducers';
import { shopAlertTopMessage } from './TopAlertMessage.reducers';
import {person} from './Person.reducer';
import {banners} from './Banners.reducer';
import {errors} from './Errors.reducer';
import {appointments} from './Appointments.reducer';
import {disabled} from './Disabled.reducer';
import {history} from './History.reducer';

const shareReducers = {  
    appointments,
    banners,  
    disabled,
    employees,
    employeeProducts,
    employeeMediaDefault,  
    errors,  
    fieldsDefination,
    person,
    products,
    productCategories,
    productResources,
    shop,
    shopAlertMessage,
    shopAlertTopMessage,
    timelines, 
    resources,
    retailer, 
    history
}


export default shareReducers;